export default "__VITE_ASSET__DG_461uf__"